function hidePartOfEmail(email: string) {
    const emailUsername = email.substring(0, email.indexOf("@"))
    const emailDomain = email.substring(email.indexOf("@") + 1)

    const hiddenEmailUsername =
        emailUsername[0] +
        "*".repeat(emailUsername.length - 2) +
        emailUsername[emailUsername.length - 1]

    return `${hiddenEmailUsername}@${emailDomain}`
}

export default hidePartOfEmail
